import PropTypes from 'prop-types'
import { iso8601DurationPropType } from '../common/iso-8601-duration-prop-type'
import { rdtDurationPropType } from './rdt-duration-prop-type'

/**
 * @typedef {Object} RdtDailyWorking
 * @property {iso8601DurationPropType} [maximumWorkingTime] - The maximum working time (ISO 8601 duration).
 * @property {rdtDurationPropType} [rawRemainingWorkingTime] - The duration object of the remaining working time (raw).
 * @property {rdtDurationPropType} [RemainingWorkingTime] - The duration object of the remaining working time.
 * @property {rdtDurationPropType} [totalWorkingTime] - The duration object of the total working time.
 */
export const rdtDailyWorkingPropType = PropTypes.shape({
    maximumWorkingTime: iso8601DurationPropType,
    rawRemainingWorkingTime: rdtDurationPropType,
    remainingWorkingTime: rdtDurationPropType,
    totalWorkingTime: rdtDurationPropType
})
